"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_HOOKS = void 0;
exports.DATA_HOOKS = {
    CLOSE_BTN: 'close-btn',
};
//# sourceMappingURL=constants.js.map